export default __webpack_public_path__ + "static/media/recursos lep.4280660e.png";